






































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { MedTransGoConstants } from '@/util/constants';
import { ObjectFactory } from '@/config/objectFactory';
import { ApiRequest } from '@/types/request';
import { ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
import { CommonUtils } from '@/util/commonUtils';

@Component({
    mixins: [validationMixin],
    data() {
        return {
            locationsExcel: {
                file: FormData,
                filename: '',
            },
        };
    },
    validations: {
        locationsExcel: {
            filename: {
                required,
            },
        },
    },
})
export default class UploadLocationsModal extends Vue {
    private show = true;
    private showDeleteConfirmBox = false;

    private async setExcel($event: any) {
        const filename = $event.target.files[0].name.toLowerCase();
        if (filename.endsWith('.xlsx')) {
            this.$data.locationsExcel.file = $event.target.files[0];
            this.$data.locationsExcel.filename = $event.target.files[0].name;
        } else {
            const toastEvent: ToastEvent = {
                message: 'File types should be xlsx',
                title: 'Invalid file format.',
                varient: 'danger',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            const inputName = 'file-input-1';
            const element = this.$refs[inputName] as any;
            element.reset();
        }
    }
    private async uploadlocations() {
        const member = ObjectFactory.getCacheService().getMemberInfo();
        const orgId = member.organization ? member.organization.id : '';
        const memberId = member.memberId ? member.memberId : '';
        const excelFormData = new FormData();
        excelFormData.append('file', this.$data.locationsExcel.file);
        excelFormData.append('organizationId', orgId);
        excelFormData.append('memberId', memberId);
        const response = await ObjectFactory.getOrganizationService().uploadlocations(this.$store.state.serverUrl,
        excelFormData);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: 'You will get a confirmation email after excel is processed.',
                title: 'Success!',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.$emit('success');
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }
    private close() {
        this.$emit('close');
    }
}
